<template>
  <div v-if="$hasFeature('track_trace') && $hasPermission('view_tracking_menu')" class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
      :menuOptions="trackMenulist"
      :selectedCategory="selectedCategory"
      :noSearchFilter="true"/>
    </portal>

    <div>
      <Row :gutter="20">
        <Col :xl="21" :lg="19" :md="17">
          <div class="loading-app" v-if="isLoading">
            <Spinner />
          </div>
          <div class="map-fullscreen" v-else-if="activeTrips.length">
            <iframe :src="trackUrl" frameborder="0" style="border:0" width="100%" height="655"/>
          </div>
          <div class="status-msg my-md" v-else>
            <span>
              <svgicon name="empty-location" width="251" height="160" :original="true" />
              <p>No pings found</p>
            </span>
          </div>
        </Col>
      </Row>

      <Drawer
        v-if="!isLoading"
        direction="rtl"
        size="345px"
        :visible="true"
        :modal="false"
        modal-wrapper="false"
        :withHeader="false"
        class="default-drawer dark">
        <div class="drawer-header">
          <span class="status status-icon status-grey text-green">
            Active Trips
            <span class="badge text-green">
              {{activeTrips.length}}
            </span>
          </span>
          <div class="drawer-search" v-bind:class="{'is-active': isSearch}">
            <svgicon name="icon-search" width="15" height="22" :original="true"
              @click="isSearch=true"/>
            <span class="search-field">
              <Input placeholder="Search"
                v-model="input"
                @input="searchTerm(input)"/>
              <svgicon name="icon-close" class="clear-icon" width="8" height="8"
                :original="true" @click="closeSearch()"/>
            </span>
          </div>
        </div>
        <div class="drawer-body">
          <ul class="drawer-list list-scroll" v-if="getSearchActiveTrips.length">
            <li class="mb-0" v-for="(activeTrip,index) in getSearchActiveTrips"
              :key="index"
              @click="tripDetails(activeTrip.id)">
              <div class="list-info pointer">
                <h6>
                  {{activeTrip.shipment_number}}
                  <small>
                    {{activeTrip.created_at | moment("DD, MMM'YY")}}
                  </small>
                </h6>
                <p>{{activeTrip.transporter_name}}</p>
                <!-- <small>2101101, Mysore Depot — 12122, Consignee</small> -->
              </div>
            </li>
          </ul>
        </div>
      </Drawer>
    </div>
  </div>
  <div v-else class="loading-app page-not-found">
      <h4>Page not found</h4>
      <p>
        Go back to <router-link :to="{ path: '/indents/v2/outbound' }">Indents</router-link>
      </p>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';
import { TrackMenu } from '@/constants/trackConstants';
import debounce from 'debounce';

export default {
  components: {
    PrimaryFilter,
  },
  data() {
    return {
      TrackMenu,
      input: '',
      activeTrips: [],
      searchActiveTrips: [],
      isLoading: false,
      isSearch: false,
    };
  },
  async created() {
    this.isLoading = true;
    this.activeTrips = await this.$store.dispatch('track/getActiveTrips');
    this.searchActiveTrips = this.activeTrips;
    this.isLoading = false;
  },
  computed: {
    selectedCategory() {
      return this.TrackMenu.find(menu => menu.id === 'Map View');
    },
    trackUrl() {
      const activeTripDetails = this.activeTrips.filter(trip => trip.latest_location);
      this.$session.set('activeTripDetails', activeTripDetails);
      return `${window.location.origin}/activeTrips/map`;
    },
    getSearchActiveTrips() {
      return this.searchActiveTrips;
    },
    trackMenulist() {
      return this.TrackMenu.filter(ele => (ele.permission ? this.$hasPermission(ele.permission) : true));
    },
  },
  methods: {
    tripDetails(activeTripId) {
      const routeData = this.$router.resolve({ name: 'TrackDetails', query: { id: activeTripId } });
      if (this.$hasPermission('view_trips')) {
        window.open(routeData.href, '_blank');
      }
    },
    searchTerm: debounce(function debounceSearch(input) {
      this.$nextTick(() => {
        const searchTerm = input.trim().toLowerCase();
        if (searchTerm) {
          this.searchActiveTrips = this.activeTrips.filter(trip =>
            trip.shipment_number.toLowerCase().includes(searchTerm));
        } else {
          this.searchActiveTrips = this.activeTrips;
        }
      });
    }, 600),
    closeSearch() {
      this.input = '';
      this.isSearch = false;
      this.searchActiveTrips = this.activeTrips;
    },
  },
};
</script>
